(function (module) {
    'use strict';

    module.config(['formlyConfigProvider', (formlyConfigProvider) => {

        formlyConfigProvider.setType({
            name: 'mdSlider',
            template: `
                    <div class="formly-slider-wrapper">
                        <div class="label">{{to.label}}</div>
                        <md-slider-container>
                            <md-slider class="formly-slider"
                                min="{{to.min}}"
                                max="{{to.max}}"
                                step="{{to.step}}"
                                ng-model="model[options.key]">
                            </md-slider>
                            <span class="slider-value">{{model[options.key]}}</span>
                        </md-slider-container>
                      </div>
            `
        });

    }]);
})(angular.module('rocket.components'));
